<template>
  <div class="editAddr">
    <!-- <van-icon name="arrow-left" @click="goBack" class='nav_goback' /> -->
    <div class="inputBox">
      <span class="t1">姓名</span>
      <input type="text" placeholder="请输入姓名"  v-model="receive_name" maxlength="6" />
    </div>
    <div class="inputBox">
      <span class="t1">手机号</span>
      <input type="text" placeholder="请输入手机号码" v-model="receive_tel" maxlength="11" />
    </div>
    <div class="inputBox" @click="show=true">
      <span class="t1">所在地区</span>
      <!-- <input type="text" :placeholder="pca" disabled /> -->
      <div class="input" :style=" pca == '请选择省市区' && 'color:#666' ">{{  pca }}</div>
      <img src="../../assets/my/next2.png" alt="">
    </div>
    <div class="textBox">
      <span class="t1">详细地址</span>
      <textarea cols="30" rows="3" placeholder="请输入详细地址" v-model="receive_address" maxlength="40"></textarea>
    </div>

    <div class="bottom">
      <div class="is_default">
        <img :src="is_defaultImg" @click="is_default = !is_default" />
        <span>设为默认</span>
      </div>
      <input class="input1" type="button" value="确认添加" @click="addReceive" />

    </div>
    <van-popup v-model="show" position="bottom">
      <van-area :area-list="areaList" @confirm="confirm" @cancel="cancel" />
    </van-popup>

  </div>
</template>
<style lang="less" scoped>
.editAddr {
  .inputBox {
    display: flex;
    align-items: center;
    background-color: #fff;
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    padding: 0 24px;
    border-bottom: 1px solid #eee;
    .t1 {
      font-size: 32px;
      color: #333;
      width: 200px;
      margin-right: 10px;
    }
    input,.input {
      flex: 1;
      font-size: 32px;
      color: #333;
      border: none;
    }
    img{
      width: 20px;
    }
  }
  .textBox {
    display: flex;
    align-items: flex-start;
    background-color: #fff;
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 30px 24px;
    border-bottom: 1px solid #eee;

    .t1 {
      font-size: 32px;
      color: #333;
      width: 200px;
      margin-right: 10px;
    }
    textarea {
      flex: 1;
      overflow: hidden;
      font-size: 32px;
      color: #333;
      border: none;
      box-sizing: border-box;
      padding: 5px;
    }
  }
  .bottom {
    margin-top: 20px;
    width: 100%;
    padding: 20px 24px;
    box-sizing: border-box;
    background-color: #fff;
    .is_default {
      font-size: 28px;
      color: #999;
      img {
        width: 49px;
        height: 49px;
        margin-right: 15px;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
      }
    }
    input {
      width: 702px;
      height: 94px;
      margin-top: 20px;
      display: block;
      box-sizing: border-box;
      border-radius: 10px;
      font-size: 32px;
      text-align: center;
      line-height: 94px;
      border: none;
    }

    .input1 {
      margin: 100px 0 20px;
      color: #fff;
      background-color: #e42129;
      -webkit-appearance:none;
    }
    .input2 {
      color: #e42129;
      background-color: #fff;
      border: 1px solid #e42129;
    }
  }
}
</style>

<script>
import AreaList from '../../lib/area'
import { constants } from 'crypto'

let flag = false
export default {
  data () {
    return {
      pca: '请选择省市区',
      is_default: true,
      areaList: AreaList,
      show: false,
      receive_name: '',
      receive_tel: '',
      receive_address: '',
      address_title: ''
    }
  },
  computed: {
    is_defaultImg () {
      return this.is_default
        ? require('../../assets/car/is_sel.png')
        : require('../../assets/car/no_sel.png')
    }
  },
  methods: {
    cancel () {
      this.show = false
    },
    confirm (e) {
      this.address_title = e.map(item => item.name).join('-')
      this.pca = e.map(item => item.name).join('')
      this.show = false
    },
    addReceive () {
      if(flag) return 

      let is_default = this.is_default ? '1' : '0'
      let receive_name = this.receive_name
      let receive_tel = this.receive_tel
      let receive_address = this.receive_address
      let address_title = this.address_title
      if (!/\S/.test(receive_name)) return this.$toast('请输入姓名')
      let telReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!telReg.test(receive_tel)) return this.$toast('请输入正确的手机号码')
      if (!/\S/.test(address_title)) return this.$toast('请选择省市区')
      if (!/\S/.test(receive_address)) return this.$toast('请输入详细地址')
      flag = true

      this.$http({
        url: 'addReceive',
        data: {
          is_default,
          receive_name,
          receive_tel,
          receive_address,
          address_title
        }
      }).then(res => {
        console.log(res)
        this.$toast('新建地址成功')
        setTimeout(() => {
          flag = false

          this.$router.go(-1)

        }, 1500)
      })
    }
  }
}
</script>
